import Wordings from './components/Wordings';
import WordingsState from './wordingsState/WordingsState';
import React from 'react';

const WordingsPage: React.FC = () => {
	return (
		<WordingsState>
			<Wordings />
		</WordingsState>
	);
};

export default WordingsPage;
